<template>
  <div id="app">
    <div v-if="!show">
      <!-- 头部 -->
      <Header  />
      <!-- -->
      <div class="wrapper" style="width: 100%; height: 100%; padding-top:80px">
        <transition name="fade" mode="out-in">
          <router-view ref="home" />

        </transition>
        <!-- 尾部 -->
          <Footer></Footer>
      </div>


    </div>
    <div class="inviteRegister" style="width: 100%; height: 100%;" v-else>
      <transition name="fade" mode="out-in">
        <router-view ref="home" />
      </transition>
    </div>
  </div>
</template>

<script>
import Header from "components/Header";
import Footer from "components/footer";
export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    $route(to, from) {
      const { show } = to.meta;
      this.show = show;

    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },

  methods: {

    getRouteMeta(meta) {
      const { show } = meta;
      this.show = show;
    },

  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
    })
    if(this.show){
      // $('.inviteRegister').css({
      //   width: $(window).width()+ 'px',
      //   height: $(window).height()+ 'px',

      // })
    }

    this.getRouteMeta(this.$route.meta);
    document.title = "深圳中青宝互动网络股份有限公司-中青宝云游戏-云中快游-云电脑玩游戏-手机,上网本轻松玩大型PC端游";
    $('meta[name="keywords"]').attr(
      "content",
      "云游戏,云电脑,云游戏平台,中青宝,中青宝云游戏,云中快游"
    );
    $('meta[name="description"]').attr(
      "content",
      "中青宝云游戏是一款适用于Android,PC,Mac,iOS的云游戏平台,游戏免下载安装,点开即玩上百款Steam游戏大作,用户通过中青宝云游戏app可将手机,电脑,平板,电视连接云端高配游戏电脑,游戏体验流畅不卡顿"
    );
    // $('meta[name=‘’]”).attr(‘content’, data[i].description);
  }
};
</script>



<style lang="scss">
#app {
  font-family: PingFangSC-Regular, "Microsoft YaHei", sans-serif;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  position: relative;
  // min-width: 1200px;
  // max-width: 1920px;
  // height: 100%;
  color: #fff;
  margin: 0 auto;
  height: 100%;
  background-size: cover;

  .wrapper {
    // overflow: hidden;
    background-color: #202e40;
    background: #202e40 url(~assets/img/body_bg.jpg) no-repeat center top;
    min-width: 1200px;
    // max-width: 1980px;
    // background-size: cover;
    // width: 100%;
    // height: 100%;
    // margin-top: -80px;
  }
  // a{
  //   display: inline-block;
  // }
}
.v-modal {
  opacity: 0.7 !important;
}

</style>
